import { render, staticRenderFns } from "./BaseReferenceCodeNameField.vue?vue&type=template&id=6d3d1a3b&scoped=true&"
import script from "./BaseReferenceCodeNameField.vue?vue&type=script&lang=js&"
export * from "./BaseReferenceCodeNameField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d1a3b",
  null
  
)

export default component.exports